/* eslint-disable */
import axios from 'axios';
import { indexOf, without } from 'lodash';

// https://medium.com/vuejs-tips/tiny-debounce-for-vue-js-cea7a1513728
function debounce (fn, delay) {
  var timeoutID = null
  return function () {
    clearTimeout(timeoutID)
    var args = arguments
    var that = this
    timeoutID = setTimeout(function () {
      fn.apply(that, args)
    }, delay)
  }
}



export const slugify = (string) => {
    const a = 'àáäâãèéëêìíïîòóöôùúüûñçßÿœæŕśńṕẃǵǹḿǘẍźḧ·/_,:;'
    const b = 'aaaaaeeeeiiiioooouuuuncsyoarsnpwgnmuxzh------'
    const p = new RegExp(a.split('').join('|'), 'g')

    return string.toString().toLowerCase()
        .replace(/\s+/g, '-') // Replace spaces with -
        .replace(p, c => b.charAt(a.indexOf(c))) // Replace special characters
        .replace(/&/g, '-and-') // Replace & with 'and'
        .replace(/[^\w-]+/g, '') // Remove all non-word characters
        .replace(/--+/g, '-') // Replace multiple - with single -
        .replace(/^-+/, '') // Trim - from start of text
        .replace(/-+$/, '') // Trim - from end of text
}

function parseUrl (url) {
  var elem = document.createElement('a')
  elem.href = url
  return {
    protocol: elem.protocol,
    host: elem.host,
    hostname: elem.hostname,
    port: elem.port,
    pathname: elem.pathname,
    hash: elem.hash
  }
}

function getCurrent (url) {
  // get the current BB-page index from the URL
  var path = parseUrl(url).pathname.split('/')
  // return parseInt(path.pop())
  return path.pop()
}



let sortBy = function (field, reverse, primer) {

  var key = primer ? function (x) { return primer(x[field]) } : function (x) { return x[field] }

  reverse = !reverse ? 1 : -1;

  return function (a, b) {
    a = key(a);
    b = key(b);
    return a === b ? 0 : reverse * ((a > b) - (b > a));    
  } 
}


function toggleItemInArray (collection, item) {
  console.log('###### toggle ', collection)
  console.log('itme: ', item)
  const index = indexOf(collection, item);
  if (index !== -1) {
    return without(collection, item);
  }
  return [...collection, item];
}


export default {
  parseUrl,
  getCurrent,
  sortBy,
  toggleItemInArray,
  debounce,

  humanDate (timestamp) {
    //return new Date(timestamp)
    moment.locale('en-gb')
    return moment(timestamp).format('LL - HH:mm')
  },

  theDate (timestamp, relative=false) {
    // centrale date format 
    let d = new Date(timestamp)
    //return d.toUTCString()
    return relative ? moment(d).fromNow() : moment(d)
    // return moment(d).format('MMMM Do YYYY, HH:mm:ss')
    // moment().startOf('day').fromNow();        // 12 hours ago

  }


}


// the Historiana API
export const API = axios.create({
  baseURL: `/api/`,
  headers: {
    Authorization: 'Bearer {token}'
  }
})
